import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";

import "@fortawesome/fontawesome-free/css/all.css";

// import logo from "../assets/img/logo.svg";

import transparentLogo from "../assets/img/transparent-logo.png";
import noBackgroundLogo from "../assets/img/white-favicon.png";

import { HashLink } from "react-router-hash-link";
import { BrowserRouter as Router } from "react-router-dom";

export const NavBar = () => {
  const [activeLink, setActiveLink] = useState("home");
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  };

  return (
    <Router>
      <Navbar expand="md" className={scrolled ? "scrolled" : ""}>
        <Container>
          <Navbar.Brand href="/">
            <img src={transparentLogo} alt="Logo" className="logo" />
            {/* <img src={noBackgroundLogo} alt="Logo" className="logo" /> */}
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link
                href="#home"
                // style={{ fontSize: "10vh" }}
                className={
                  activeLink === "home" ? "active navbar-link" : "navbar-link"
                }
                onClick={() => onUpdateActiveLink("home")}
              >
                Home
              </Nav.Link>
              <Nav.Link
                href="#skills"
                className={
                  activeLink === "skills" ? "active navbar-link" : "navbar-link"
                }
                onClick={() => onUpdateActiveLink("skills")}
              >
                Skills
              </Nav.Link>
              <Nav.Link
                href="#projects"
                className={
                  activeLink === "projects"
                    ? "active navbar-link"
                    : "navbar-link"
                }
                onClick={() => onUpdateActiveLink("projects")}
              >
                Projects
              </Nav.Link>
            </Nav>
            <span className="navbar-text">
              <div className="social-icon">
                <a
                  href="https://www.linkedin.com/in/miriam-maina-962693167/"
                  className="text-white hover:text-gray-400"
                >
                  <i className="fab fa-linkedin fa-lg"></i>
                </a>
                <a
                  href="https://github.com/wahitom"
                  className="text-white hover:text-gray-400"
                >
                  <i className="fab fa-whatsapp fa-lg"></i>
                </a>

                <a href="#" className="text-white hover:text-gray-400">
                  <i className="fab fa-twitter fa-lg"></i>
                </a>
                <a href="#" className="text-white hover:text-gray-400">
                  <i className="fab fa-github fa-lg"></i>
                </a>
              </div>
              <HashLink to="#connect">
                <button className="vvd">
                  <span>Let’s Connect</span>
                </button>
              </HashLink>
            </span>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </Router>
  );
};
